import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    this.element.value = timezone
  }
}
